require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-lucy-lofthouse.json") })
        }
      }, "path---people-lucy-lofthouse");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-lucy-lofthouse!./.cache/json/people-lucy-lofthouse.json
// module id = 1462
// module chunks = 231608221292675